import './App.css';
import { setCookie, getCookie, initializeTracking } from '@elevenia/edts-tracker'
import { v4 as uuidv4 } from 'uuid';
import NavbarNavigate from './component/navbar';
import CarouselNavigate from './component/carousel';
import CardNavigate from './component/card';
import FooterNavigate from './component/footer';
import { useEffect } from 'react';
import ModalEffect from './component/modal';
import { useState } from 'react';
import TrayInfo from './component/TrayInfo';
import imageBody1 from 'assets/image/image-body-1.png'
import imageBody2 from 'assets/image/image-body-2.png'
import imageBody3 from 'assets/image/image-body-3.png'
import imageBody4 from 'assets/image/image-body-4.png'
import ModalJquery from 'component/modalJquery';
// import imageBody5 from 'assets/image/image-body-5.png'
// import imageBody6 from 'assets/image/image-body-6.png'
// import imageBody7 from 'assets/image/image-body-7.png'
// import imageBody8 from 'assets/image/image-body-8.png'

function App() {
  const isCookiesExists = getCookie({ keyname: "session_id" });
  const [isOpen, setOpen] = useState(false)
  const [isOpenJquery, setOpenJquery] = useState(false)
  const [openTray, setOpenTray] = useState(null)
  const [res, setRes] = useState(null)
  const [loading, setloading] = useState(false)
  useEffect(() => {
    setCookie({ keyname: "session_id", keyvalue: uuidv4(), minutes: 30 });
  }, [isCookiesExists, isOpen, res])
  const tracking = ({ payload }) => {
    setloading(!loading)
    initializeTracking({ ...payload }).then(res => {
      setRes(res)
      setloading(false)
    }).catch(e => {
      setRes(JSON.parse(JSON.stringify(e)))
      setloading(false)
    })
  }
  return (
    <div>
      <NavbarNavigate setOpen={setOpen} setOpenJquery={setOpenJquery}/>
      <CarouselNavigate setOpenTray={() => setOpenTray(!openTray)} />
      <div style={{ padding: 10 }}>
        <div style={{ textAlign: "center", paddingBotton: 12 }}>
          <h2>Dolor Lipsum Sit Amet</h2>
        </div>
        <CardNavigate array={[imageBody1, imageBody2, imageBody3, imageBody4]} />
      </div>
      <div className="float">
        <i className="fa-solid fa-times fa-2x"></i>
      </div>
      {openTray !== null && <TrayInfo loading={loading} tracking={tracking} setRes={setRes} response={res} open={openTray} setOpenTray={() => setOpenTray(!openTray)} />}
      <ModalEffect isOpen={isOpen ? true : false} setOpen={() => setOpen(!isOpen)} />
      <ModalJquery isOpen={isOpenJquery ? true : false} setOpen={() => setOpenJquery(!isOpenJquery)} />
      <FooterNavigate />
    </div>
  );
}

export default App;

